import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { first } from "rxjs/operators";
import { AlertService, ConnectorService, Constant, ConnectionService } from "../_services";

@Component({
  selector: 'api-authenticate',
  templateUrl: './authenticate.api.html'
})
export class AuthenticateAPI implements OnInit {
  form: FormGroup;
  loading = false;
  submitted = false;
  @Input() item = ''; // decorate the property with @Input()
  @Input() flg = '';
  @Input() cID = '';
  label_nm: string;
  auid: string;
  AutomationApiData = null;
  @Output() someEvent = new EventEmitter<string>();
  constructor(private connectionservice: ConnectionService, private alertService: AlertService, private constant: Constant, private formBuilder: FormBuilder, private route: ActivatedRoute,
    private router: Router) {
   }
  ngOnInit(): void {
    this.auid = this.route.snapshot.params['auid'];
    this.form = this.formBuilder.group({
    
      autoUserID: ['', Validators.required],
      cID: this.auid,
      flag: this.flg,
      uId: this.item
    });
    this.connectionservice.SelectedConnectorDetail(this.item)
      .pipe(first())
      .subscribe(
        AutomationApiData => {
          this.AutomationApiData = AutomationApiData
          this.label_nm = AutomationApiData.label_nm;

        });
  }
  get f() { return this.form.controls; }

  onSubmit() {
    this.submitted = true;
    this.alertService.clear();
    if (this.form.invalid) {

      return;
    }
    this.loading = true;
    this.SaveDetail();
  }
  private SaveDetail() {
    this.connectionservice.savedetail(this.form.value)
      .pipe(first())
      .subscribe(
        data => {
          this.loading = false;
          if (!data.isSuccess) {
            this.alertService.error(data.message);
          }
          else {
            this.alertService.success(data.message, { keepAfterRouteChange: true });
            // this.someEvent.next('somePhone');

            return 'by pressing ESC';
          }
        },
        error => {
          this.alertService.error(error);
          this.loading = false;
        });
  }


}
